import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import { ResetCSS } from 'common/source/assets/css/style';
import { theme } from 'common/source/styles/theme';
import { GlobalStyle, ContentWrapper } from 'common/source/styles';
import Navbar from 'common/source/containers/SolarNavbar';
import Banner from 'common/source/containers/Banner';
import Footer from 'common/source/containers/Footer';
import CTABanner from 'common/source/containers/CTABanner';

import Container from 'common/source/components/UI/Container';

import SEO from '../components/SEO';
import PageContent from '../components/PageContent';
import config from '../../data/SiteConfig';

class FaqsPage extends React.Component {
  render() {
    const { data } = this.props;
    const { page } = data;
    const { html, frontmatter } = page;
    return (
      <ThemeProvider theme={theme}>
        <Fragment>
          <SEO
            pageTitle={`${frontmatter.title} | ${config.siteTitle}`}
            path={`/${frontmatter.slug}`}
          />
          <ResetCSS />
          <GlobalStyle />

          <ContentWrapper>
            <Navbar />
            <Banner heading={frontmatter.title} />
            <Container>
              <PageContent html={html} />
            </Container>
            <CTABanner />
            <Footer />
          </ContentWrapper>
        </Fragment>
      </ThemeProvider>
    );
  }
}
export default FaqsPage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query FaqsQuery {
    page: markdownRemark(frontmatter: { slug: { eq: "preguntas-frecuentes" } }) {
      html
      timeToRead
      excerpt
      fields {
        slug
      }
      frontmatter {
        slug
        title
        subtitle
        description
        type
        cover
        thumbnail
      }
    }
  }
`;
